import debounce from 'lodash/debounce';
import {FC, ReactElement, useEffect, useMemo, useState} from 'react';

export type WindowParams = {
  width: number;
  height: number;
  isMobile: boolean;
  mobileMaxW: number;
};

type Props = {
  mobileMaxW?: number;
  resizeDebounceMs?: number;
  children: (windowParams: WindowParams) => ReactElement | null;
};

// ipadWidth = 1050
//  - https://github.yandex-team.ru/milab/back-to-life-frontend/blob/master/src/styles/variables.scss
// mobileWidth = 740
//  - https://github.yandex-team.ru/milab/back-to-life-frontend/blob/master/src/styles/variables.scss
// mobileWidth = 800
//  - https://github.yandex-team.ru/milab/local-words/blob/master/src/styles/variables.scss

const WindowResizeWatcher: FC<Props> = ({children, mobileMaxW = 800, resizeDebounceMs = 200}) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = useMemo(() => {
    return debounce(() => {
      // document.body.clientWidth ?
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }, resizeDebounceMs);
  }, [resizeDebounceMs]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  const isMobile = width < mobileMaxW;
  return children({width, height, isMobile, mobileMaxW});
};

export default WindowResizeWatcher;
